(function () {
var SR_WORKER_URL = "https://purple-base-4d36.sandeep-pandey-a6b.workers.dev";
function esc(s) {
return String(s || "")
.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
.replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function show(el, html) {
el.style.display = "block";
el.innerHTML = html;
}
function formatDate(date) {
var months = ["Jan","Feb","Mar","Apr","May","Jun",
"Jul","Aug","Sep","Oct","Nov","Dec"];
return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
}
window.srCheckDelivery = async function (productId) {
var pinEl    = document.getElementById("sr-pincode-"   + productId);
var resultEl = document.getElementById("sr-result-"    + productId);
var btn      = document.getElementById("sr-check-btn-" + productId);
var pincode  = (pinEl ? pinEl.value : "").trim();
if (!/^\d{6}$/.test(pincode)) {
show(resultEl, '<div class="sr-msg sr-msg--error">⚠ Enter a valid 6-digit pincode.</div>');
return;
}
btn.disabled = true;
show(resultEl, '<div class="sr-loading"><span class="sr-spin"></span> Checking ' + esc(pincode) + '…</div>');

try {
var resp = await fetch(SR_WORKER_URL + "?pincode=" + pincode);
if (!resp.ok) throw new Error("Worker error: " + resp.status);

var data = await resp.json();
if (data.error) throw new Error(data.error);

if (!data.available || !data.couriers || !data.couriers.length) {
show(resultEl,
'<div class="sr-msg sr-msg--unavail">' +
'<span class="sr-dot sr-dot--red"></span>' +
'Delivery <strong>not available</strong> to <strong>' + esc(pincode) + '</strong>' +
'</div>'
);
return;
}

// Find the MAX estimated delivery days across all couriers
var maxDays = 0;
data.couriers.forEach(function (c) {
var days = parseFloat(c.estimated_delivery_days);
if (!isNaN(days) && days > maxDays) {
maxDays = days;
}
});

// Add 3 buffer days
var totalDays = maxDays + 3;

// Calculate the estimated delivery date
var deliveryDate = new Date();
deliveryDate.setDate(deliveryDate.getDate() + totalDays);
var dateStr = formatDate(deliveryDate);

show(resultEl,
'<div class="sr-msg sr-msg--avail">' +
'<span class="sr-dot sr-dot--green"></span>' +
'Delivery available to <strong>' + esc(pincode) + '</strong>' +
'</div>' +
'<div class="sr-delivery-date">' +
'Estimated Delivery by <strong>' + esc(dateStr) + '</strong>' +
'</div>'
);

} catch (err) {
console.error("[Shiprocket]", err);
show(resultEl,
'<div class="sr-msg sr-msg--error">' +
'⚠ Could not check delivery. Please try again.<br>' +
'<small>' + esc(err.message) + '</small>' +
'</div>'
);
} finally {
btn.disabled = false;
}
};

document.addEventListener("keydown", function (e) {
if (e.key === "Enter" && e.target.classList.contains("sr-pincode-input")) {
var wrap = e.target.closest(".sr-wrap");
if (wrap) { var b = wrap.querySelector("[id^='sr-check-btn-']"); if (b) b.click(); }
}
});

})();